import { Component, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { EventEmitter } from '@angular/common/src/facade/async';
import { GridOptions } from 'ag-grid';
import { OnDemandDriversService } from '../../on-demand-drivers.service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-on-demand-drivers-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss']
})
export class LogsComponent implements OnInit, OnChanges {

  private logGrid: GridOptions;

  @Input() selected: number;
  @Output() notify: EventEmitter < boolean > = new EventEmitter < boolean > ();
  @Output() cancel: EventEmitter < boolean > = new EventEmitter < boolean > ();


  constructor(
    protected service: OnDemandDriversService,
    private sweetAlertHelper: SweetAlertHelper
  ) {
    this.logGrid = < GridOptions > {};
    this.configureGrid();
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    const selectedChange = changes['selected'];

    if (
      selectedChange &&
      !selectedChange.isFirstChange() &&
      selectedChange.currentValue &&
      selectedChange.currentValue !== selectedChange.previousValue
    ) {
      if (this.logGrid && this.logGrid.api) {
        this.logGrid.api.setRowData([]);
      }
      this.getLog();
    }
  }

  /**
   * @name cancelCreateEdit
   * @description
   */
  public cancelCreateEdit() {
    this.cancel.emit(true);
  }

  /**
   * @name getLog
   * @description
   */
  private getLog() {
    this.service
    .getLog(this.selected)
    .subscribe(
      data => {
        if (this.logGrid) {
          if (this.logGrid.api) {
            this.logGrid.api.setRowData(data)
          }
        }
      },
      (error) => {
        this.sweetAlertHelper.captureException(error);
      }
    );
  }

  /**
   * @name configureGrid
   * @description
   */
  private configureGrid() {
    const self = this;
    this.logGrid.columnDefs = [{
        headerName: 'Section',
        field: 'sessiontokenid',
        colId: 'sessiontokenid'
      }, {
        headerName: 'Log In',
        field: 'logindate',
        colId: 'logindate'
      }, {
        headerName: 'Log Out',
        field: 'logoutdate',
        colId: 'logoutdate'
      }, {
        headerName: 'Trips',
        field: 'drivertrips',
        colId: 'drivertrips'
      }, {
        headerName: 'Time on Task',
        field: 'timeontask',
        colId: 'timeontask'
      }, {
        headerName: 'Available Time',
        field: 'availabletime',
        colId: 'availabletime'
      }
    ];

    this.logGrid.onGridReady = function () {
      self.logGrid.api.sizeColumnsToFit();
      self.getLog();
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/on-demand-drivers/components/logs/logs.component.ts